import { useDispatch } from 'react-redux'
import { useCart } from 'Checkout/Hooks/useCart'
import { useRedirects } from 'Checkout/Hooks/useRedirects'
import { clearSearch } from 'Checkout/Redux/Actions/Search'
import { Button } from 'reactstrap'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const CLEAR_SEARCH_KEYS_TO_IGNORE = ['accommodation', 'dayUse', 'marketplaceOverrideUuid']

const CompleteReservationButton = ({ groupErrors, nanoId }) => {
  const dispatch = useDispatch()
  const { homeRedirect } = useRedirects()
  const { fillCurrentReservationFromCart, removeReservation } = useCart()

  const onClick = () => {
    if (groupErrors.isRateUnavailable) return onRateUnavailable()
    if (groupErrors.isSiteUnavailable) return onSiteUnavailable()
    if (groupErrors.isUnavailableByDates) return onDatesUnavailable()

    fillCurrentReservationFromCart(nanoId, { withRedirectTo: 'details' })
  }

  const onRateUnavailable = () => {
    fillCurrentReservationFromCart(nanoId, { exceptSearchFilter: ['rate', 'site'], withRedirectTo: 'search' })
  }

  const onSiteUnavailable = () => {
    fillCurrentReservationFromCart(nanoId, { exceptSearchFilter: ['site'], withRedirectTo: 'sites' })
  }

  const onDatesUnavailable = () => {
    removeReservation(nanoId)
    dispatch(clearSearch({ except: CLEAR_SEARCH_KEYS_TO_IGNORE }))
    homeRedirect()
  }

  return (
    <Button color="blue-dark" onClick={onClick}>
      <FontAwesomeIcon className="me-2" icon="pen-to-square" size="sm" />

      Complete Reservation
    </Button>
  )
}

export default CompleteReservationButton
